import React from 'react';
import { Skeleton } from 'antd';

import styled from 'styled-components';
import {
  SIZE_BORDER_RADIUS_DATA,
  SIZE_BORDER_RADIUS_ENUM,
} from '../../theme/size';
import { VALUE_OPACITY_DATA, VALUE_OPACITY_ENUM } from '../../theme/value';
import { Spacing } from '../../theme';

export const Elem: React.FC = ({}) => {
  return <SkeletonTitle active />;
};

const SkeletonTitle = styled(Skeleton)`
  padding: unset;

  gap: ${Spacing(5)};
  margin: unset;
  margin: unset;
  width: 100%;
  opacity: ${VALUE_OPACITY_DATA[VALUE_OPACITY_ENUM.SKELETON]};

  .ant-skeleton-content {
    ul {
      margin: 0 0 12px !important;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
    li {
      margin: unset !important;
      width: 100% !important;
    }
    .ant-skeleton-paragraph {
      margin: unset !important;
      display: none;
    }
    .ant-skeleton-title {
      width: 100% !important;
      border-radius: ${SIZE_BORDER_RADIUS_DATA[
        SIZE_BORDER_RADIUS_ENUM.CONTENT
      ]}px;

      height: 1em;
      margin: unset;
      background-image: linear-gradient(
        90deg,
        rgba(110, 108, 108, 0.06) 25%,
        rgba(165, 161, 139, 0.08) 37%,
        rgba(107, 104, 104, 0.06) 63%
      ) !important;
    }
  }
`;
